var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9924 14.6016C24.9924 16.727 24.9619 18.8585 24.9985 20.9839C25.0413 23.2177 23.1976 25.0119 20.9266 24.9999C16.8486 24.9818 12.7706 24.9939 8.68648 24.9939C8.076 24.9939 7.46552 25.0179 6.86724 24.8674C5.12737 24.4399 3.87589 22.9286 3.85147 21.1585C3.83316 19.304 3.84536 17.4435 3.85147 15.5891C3.85147 15.1074 4.07735 14.7943 4.46195 14.6859C4.83434 14.5835 5.19453 14.704 5.40209 15.005C5.54861 15.2218 5.56082 15.4747 5.56082 15.7275C5.56082 17.4857 5.56082 19.2378 5.56082 20.9959C5.56082 22.3386 6.51927 23.2959 7.88064 23.2959C12.154 23.2959 16.4274 23.2658 20.7007 23.314C22.1109 23.3321 23.3319 22.4951 23.3197 20.7129C23.2892 17.7024 23.3136 14.6919 23.3136 11.6814C23.3136 10.5555 23.3136 9.4356 23.3136 8.30967C23.3075 7.65338 23.1732 7.03322 22.7031 6.53348C22.1903 5.98556 21.531 5.80493 20.7984 5.79891C19.1501 5.79289 17.5018 5.79289 15.8535 5.79891C15.4933 5.79891 15.2125 5.67247 15.0538 5.34734C14.7669 4.7633 15.1515 4.1612 15.823 4.15518C16.7387 4.14314 17.6544 4.14916 18.5702 4.14916C19.3821 4.14916 20.2001 4.14314 21.0121 4.14916C23.2831 4.15518 24.9863 5.84106 24.9863 8.07485C24.9924 10.2424 24.9924 12.422 24.9924 14.6016Z",
    fill: "url(#paint0_linear_780_8282)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32458 0C6.53825 0.006021 6.61761 0.144504 6.67866 0.313092C6.96558 1.12593 7.25251 1.94478 7.54554 2.7516C7.64932 3.03458 7.77752 3.30553 7.89962 3.58249C8.20486 4.28093 8.78482 4.66025 9.47466 4.91313C10.4026 5.24429 11.3366 5.55738 12.2646 5.87649C12.466 5.94272 12.6736 5.99691 12.6736 6.2498C12.6736 6.49064 12.466 6.54482 12.2829 6.61106C11.3549 6.93619 10.427 7.27337 9.49297 7.58044C8.53452 7.89955 7.96067 8.55584 7.64322 9.47103C7.35019 10.3019 7.05105 11.1388 6.75802 11.9697C6.7275 12.054 6.69087 12.1383 6.66645 12.2226C6.61761 12.3972 6.51383 12.5116 6.32458 12.5056C6.14754 12.4996 6.06207 12.3731 6.00713 12.2226C5.78736 11.5964 5.57369 10.9703 5.34781 10.3441C5.23182 10.025 5.09141 9.70585 4.99373 9.38071C4.68239 8.37521 3.95591 7.81525 2.98525 7.49614C2.13668 7.21315 1.29422 6.92415 0.445651 6.63514C0.378498 6.61105 0.311345 6.58095 0.244192 6.55687C0.0976769 6.5087 0 6.4244 0 6.25582C0.00610481 6.09325 0.0915721 5.99691 0.238087 5.94272C0.689843 5.78618 1.13549 5.62963 1.58725 5.46707C2.25267 5.23225 2.93031 5.02151 3.58352 4.7325C4.26726 4.43145 4.67018 3.90161 4.92658 3.24532C5.28066 2.36023 5.592 1.44504 5.92166 0.54189C5.9644 0.42147 6.01323 0.295029 6.06818 0.18063C6.11702 0.066231 6.20248 0.006021 6.32458 0Z",
    fill: "url(#paint1_linear_780_8282)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6311 9.98844C13.6384 9.9764 13.5041 9.9764 13.7971 10.8133C14.6945 13.3903 15.5919 15.9733 16.4832 18.5503C16.5138 18.6466 16.5443 18.743 16.5565 18.8393C16.5809 19.1223 16.4466 19.2728 16.1536 19.2788C15.8911 19.2849 15.6225 19.2668 15.36 19.2849C15.0608 19.3029 14.896 19.1825 14.7983 18.8935C14.5724 18.1951 14.316 17.5087 14.0902 16.8163C14.023 16.6176 13.9192 16.5513 13.7117 16.5513C12.9791 16.5574 12.2465 16.5634 11.5139 16.5513C11.282 16.5453 11.1721 16.6296 11.0988 16.8524C10.879 17.5629 10.6287 18.2613 10.4029 18.9657C10.3296 19.2006 10.1892 19.2849 9.9511 19.2788C9.6886 19.2728 9.41998 19.2788 9.15748 19.2788C8.77288 19.2728 8.62026 19.0681 8.74235 18.7068C9.0537 17.7856 9.37725 16.8644 9.6947 15.9432C10.3052 14.167 10.9218 12.3968 11.5322 10.6206C11.7459 9.99446 11.7581 9.98242 12.4358 9.98242C12.509 9.98844 12.5701 9.98844 12.6311 9.98844ZM12.6128 12.2945C12.2892 13.2157 11.9962 14.0586 11.7093 14.9016C11.6482 15.0762 11.7764 15.1123 11.9169 15.1123C12.3869 15.1123 12.8509 15.1123 13.321 15.1123C13.5285 15.1123 13.5651 15.01 13.498 14.8414C13.4247 14.6427 13.3576 14.444 13.2904 14.2453C13.0768 13.6191 12.857 12.9989 12.6128 12.2945Z",
    fill: "url(#paint2_linear_780_8282)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8867 14.6249C17.8867 13.2943 17.8867 11.9576 17.8867 10.627C17.8867 10.1212 18.0271 9.98876 18.5399 9.98876C18.7536 9.98876 18.9673 9.98274 19.1809 10.0008C19.4129 10.0189 19.5594 10.1393 19.5777 10.3801C19.5899 10.5306 19.6022 10.6812 19.6022 10.8317C19.6022 13.4207 19.6022 16.0037 19.6022 18.5928C19.6022 18.7312 19.596 18.8757 19.5655 19.0082C19.5228 19.1949 19.4007 19.2972 19.1931 19.2972C18.9306 19.2912 18.662 19.2912 18.3995 19.2972C18.0393 19.2972 17.8989 19.1768 17.8928 18.8216C17.8867 18.2917 17.8928 17.7619 17.8928 17.226C17.8867 16.353 17.8867 15.4859 17.8867 14.6249Z",
    fill: "url(#paint3_linear_780_8282)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8667 1.58904C11.8667 1.64925 11.8362 1.68538 11.7873 1.70946C11.7202 1.73957 11.6591 1.76967 11.5859 1.78171C11.0242 1.89009 10.7007 2.23329 10.5786 2.7812C10.5542 2.87753 10.5481 3.02806 10.4077 3.02806C10.2856 3.02806 10.2856 2.88958 10.2428 2.79926C10.2123 2.73303 10.1757 2.67282 10.1635 2.60659C10.0902 2.13695 9.77886 1.92622 9.34542 1.8359C9.32711 1.82988 9.30269 1.82386 9.29048 1.81784C9.17449 1.75161 8.96082 1.75763 8.96692 1.59506C8.97303 1.45056 9.16838 1.43852 9.29048 1.41443C9.86433 1.31208 10.1146 0.92071 10.2428 0.408925C10.2672 0.31861 10.2611 0.186149 10.3893 0.174107C10.5237 0.162065 10.5481 0.294526 10.5664 0.384841C10.6885 0.98092 11.0365 1.34218 11.653 1.45056C11.7324 1.45658 11.8301 1.4927 11.8667 1.58904Z",
    fill: "url(#paint4_linear_780_8282)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_780_8282",
    x1: 2.8616,
    y1: 1.48743,
    x2: 23.5935,
    y2: 25.5544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#3575DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1FA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_780_8282",
    x1: 2.43918,
    y1: 1.85118,
    x2: 23.1711,
    y2: 25.9181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#3575DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1FA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_780_8282",
    x1: 0.962741,
    y1: 3.12287,
    x2: 21.6946,
    y2: 27.1898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#3575DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1FA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_780_8282",
    x1: 5.25854,
    y1: -0.577889,
    x2: 25.9904,
    y2: 23.489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#3575DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1FA2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_780_8282",
    x1: 7.08475,
    y1: -2.15203,
    x2: 27.8167,
    y2: 21.9149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FAD4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    stopColor: "#3575DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AC1FA2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.298436376895d99a4c147904180a8986.svg";
export { ForwardRef as ReactComponent };